import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { TEST } from '../../constants/RouteConst';
import { contactDetails } from '../../shared/Lang/contactUs';
import { setSentenceList } from '../../store/actions/testActions';
import { Paper } from '@mui/material';
import { copyToClipImg, arrow_left, arrow_right } from '../UI/Icons';
import FAQ from './FAQ'
import LineGraph from './LineGraph'
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import Histogram from './Histogram';
import Button from '../UI/Button'
import api from '../../shared/apiSetup'
import Notification from '../UI/Snackbar'
import resultClass from './Results.module.css'
import ResultBar from './ResultBar';
import ResultHighlights from './ResultHighlights'
import { getResultsData } from '../../shared/apiUtil'
import Loader from '../UI/Progress'
import { resultBarData, resHighData } from './Util';
import styles from '../Questionnaire/Questionnaire.module.css'

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const Results = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const questionPageLang = useSelector(state => state.user.questionPageLang);
  const resData = useSelector(state => state.results.wpmHistogramData);
  const continueCode = useSelector(state => state.user.continueCode);
  const isExistingCode = useSelector(state => state.user.isExistingCode);
  const restultPageLang = useSelector(state => state.user.restultPageLang);
  const isMobile = useSelector(state => state.home.isMobileDev);
  const lang = useSelector(state => state.user.appLang);
  const uid = useSelector(state => state.user.uid);

  const [email, setInputVal] = useState('');
  const [copySuccess, setCopySuccess] = useState('');
  const [isNotif, setNotif] = useState(false);
  const [notifMsg, setNotifMsg] = useState('');
  const [prevIds, setPrevIds] = useState(null);
  const [allIds, setAllIds] = useState([uid]);
  const [resultIndex, setResultIndex] = useState(0);
  const [histogramData, setResData] = useState(null);
  const [isPrevRes, setIsPrevRes] = useState(false);
  const [prevResIndex, setPrevResIndex] = useState(0);
  const [isLoader, setLoader] = useState(false);

  const btnDataNext = {
    btnName: questionPageLang.nextButton,
  }

  const btnDataBack = {
    btnName: (lang === "English") ? "Previous" : "Vorheriges",
  }

  const fetchPreviousSessions = async () => {
    setLoader(true)
    const continue_code = continueCode
    const tempAllIds = [...allIds]
    try {
      const response = await api.get(`/result/previous-sessions?continue_code=${continue_code}`);
      if (response.data.participant_ids.length > 1) {
        const filterArr = response.data.participant_ids.filter(each => each !== uid)
        filterArr.sort((a, b) => b - a);
        tempAllIds.push(...filterArr)
        setAllIds(tempAllIds)
      }
      setTimeout(() => {
        setLoader(false)
      }, 2000);
    } catch (error) {
      console.error('Error fetching previous sessions:', error);
      throw error;
    }
  }

  useEffect(() => {
    setResData(resData)
  }, [resData])

  useEffect(() => {
    fetchPreviousSessions()
  }, [])


  const subHeading = {
    fontWeight: 500,
    fontSize: isMobile ? 16 : 20
  }

  const btnData = {
    btnName: (lang === 'English')? "Continue Test": "Test fortsetzen",
    width: '100%',
    height: 50
  }

  const sendEmailBtn = {
    btnName: "Send",
    textAlign: 'center',
    width: '100%',
    height: 50
  }

  const prevResBtn = {
    btnName: isPrevRes ? "Today's results" : "Previous Results",
    textAlign: 'center',
    width: isMobile ? '100%' : '365px',
    height: 50
  }

  const onSendContCode = async () => {
    const formData = new FormData();
    formData.append('email', email);
    formData.append('uid', uid)
    formData.append('url', window.location.hostname)

    try {
      const response = await api.post('/result/sendContinueCode', formData);
      if (response.status === 200) {
        setNotif(true)
        setNotifMsg(response.data.message)
      }
    } catch (error) {
      console.error('Error:', error);
    }
  }

  const onContinueTest = async () => {
    const appLang = {
      lang: lang
    }
    try {
      const response = await api.post('/home/getSentences', appLang);
      dispatch(setSentenceList(response.data.sentenceList))
      navigate(TEST);
    } catch (error) {
      console.error('Error fetching string array:', error);
    }
    navigate(TEST);
  }

  const onInputChange = (e) => {
    setInputVal(e.target.value)
  }

  const copyToClipboard = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopySuccess("Copied to clipboard!");
        setTimeout(function () {
          setCopySuccess("");
        }, 3000);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const fetchResData = async (uid) => {
    getResultsData(uid)
      .then(resultData => {
        //      setIsPrevRes(true)
        setResData(resultData)
        setTimeout(() => {
          setLoader(false)
        }, 1200);
      })
      .catch(error => {
        console.error(error);
      });
  }

  const fetchPrevRes = (prevId) => {
    if (isPrevRes) {
      setIsPrevRes(false)
      setResData(resData)
      setPrevResIndex(0)
    } else {
      fetchResData(prevId)
    }
  }

  const onLeftArrowClick = () => {
    setLoader(true)
    // if (prevResIndex > 0) {
    //   setPrevResIndex(prevResIndex - 1)
    //   fetchResData(prevIds[prevResIndex - 1])
    // }
    
    if (resultIndex < allIds.length - 1) {
      setResultIndex(resultIndex + 1)
      fetchResData(allIds[resultIndex + 1])
    }
  }

  const onRightArrowClick = () => {
    setLoader(true)
    // if (prevResIndex < prevIds.length - 1) {
    //   setPrevResIndex(prevResIndex + 1)
    //   fetchResData(prevIds[prevResIndex + 1])
    // }
    
    if (resultIndex > 0) {
      setResultIndex(resultIndex - 1)
      fetchResData(allIds[resultIndex - 1])
    }
  }

  return (
    <div className={resultClass.resultsContainer}>
      {
        isNotif && <Notification isOpen={true} msg={notifMsg} notifType="success" isAutoHide={true} onNotifClose={() => setNotif(false)} />
      }
      <div className={resultClass.resultBarWrap}>
        {
          histogramData &&
          <ResultBar
            resultBarVals={
              resultBarData(
                isMobile,
                lang,
                Math.ceil(histogramData.avgWPM),
                histogramData.backspaceData.avg_backspace.toFixed(2),
                parseInt(histogramData.avgErrRate))
            }
            isMobile={isMobile}
          />
        }
        {
          (
            <div style={{ display: 'flex', flexDirection: 'column', width: isMobile ? '100%': '25%' }}>
              <div className={resultClass.continueTypTxt}>
                {restultPageLang.title.continueTitle}
              </div>
              <Button
                checkIsDisable={false}
                btnData={btnData}
                handleBtnClick={() => onContinueTest()}
              />
            </div>
          )
        }
      </div>
      <div className={resultClass.continueCodeWrap}>
        <Paper sx={{ padding: isPrevRes ? 0 : 2, display: 'flex', flexDirection: 'column', marginTop: isMobile? 2 : 6  }}>
          {
            // !isExistingCode && (
              <>
                <div style={{ fontSize: 16 }}>
                  <div className={resultClass.contCodeTxt}>{restultPageLang.title.codeTitle}</div>
                  {restultPageLang.contCodeDetail.line1}<br />
                  {restultPageLang.contCodeDetail.line2}
                </div>
                <Divider variant="left" sx={{ marginTop: 2, marginBottom: 1 }} />
                <div style={{ fontWeight: 'bold', marginBottom: 10, fontSize: 16, color: '#008080' }}>{restultPageLang.title.contCodeTitle}</div>
                <div>
                  <div className={resultClass.copyToClipWrap}>
                    {histogramData && histogramData.contCode}
                    {
                      histogramData &&
                      <img
                        className={resultClass.copyToClipIcon}
                        src={copyToClipImg}
                        alt="copytoclip"
                        onClick={() => copyToClipboard(histogramData.contCode)}
                      />
                    }
                  </div>
                  {copySuccess && <b>{copySuccess}</b>}
                </div>
                <Divider variant="left" sx={{ marginTop: 2, marginBottom: 1 }} />
                <div style={{ fontSize: 16 }}>
                  {restultPageLang.emailInfo.title}
                </div>
                <div className={resultClass.inputWrap}>
                  <input
                    // ref={inputRef}
                    type="email"
                    autoFocus
                    placeholder="name@example.com"
                    className={resultClass.emailInput}
                    value={email}
                    onChange={(e) => onInputChange(e)}
                  />
                </div>
                <Button
                  checkIsDisable={!emailRegex.test(email)}
                  btnData={sendEmailBtn}
                  handleBtnClick={() => onSendContCode()}
                />
              </>
            // )
          }
        </Paper>
      </div>
      <Grid container spacing={6} sx={{ justifyContent: isPrevRes ? 'center' : 'left', opacity: isLoader ? '0.5' : 'none' }}>
        <Grid item xs={isMobile ? 12 : 8}>
          <div className={resultClass.graphHeading}>
            {restultPageLang.title.histogramTitle}
          </div>
          {histogramData && (
            <>
              <Histogram
                //    globalWPM={histogramData.globalWPM}
                pid={allIds[resultIndex]}
                // isPrevRes={isPrevRes}
                resultIndex={resultIndex}
              />
              <LineGraph
                avgWPM={histogramData.avgWPM && parseInt(histogramData.avgWPM[0])}
                allWPM={histogramData.allWPM}
                allErr={histogramData.allErr}
                allInput={histogramData.allInput}
                globalWPM={histogramData.globalWPM}
                isMobile={isMobile}
                // isPrevRes={isPrevRes}
                resultIndex={resultIndex}
              />
            </>
          )
          }
        </Grid>
      </Grid>
      {
        histogramData &&
        <ResultHighlights
          resHighData={resHighData(restultPageLang, histogramData)}
          histogramData={histogramData}
          isMobile={isMobile}
        />
      }
      {
        (allIds.length > 1) && (
          <div className={styles.questionBtnsWrap} >
            {
              // prevResIndex !== 0 &&
              (resultIndex >= 0 && resultIndex < (allIds.length - 1)) &&
              (
                <div className={styles.buttonLeft} style={{ marginBottom: 0, marginLeft: '6%' }}>
                  <Button btnData={btnDataBack}
                    // handleBtnClick={() => onLeftArrowClick()}
                    handleBtnClick={() => onLeftArrowClick()}
                  />
                </div>
              )
            }
            {
              // prevResIndex !== (prevIds.length - 1) &&
              (resultIndex > 0) &&
              (
                <div className={styles.buttonRight} style={{ marginBottom: 0, marginRight: '6%' }}>
                  <Button btnData={btnDataNext} handleBtnClick={() => onRightArrowClick()} />
                </div>
              )
            }
          </div>
        )
      }
      {
        (
          <>
            <div style={{ marginTop: isMobile ? 25 : 125 }}>
              <FAQ faqData={restultPageLang.faq} isMobile={isMobile} />
            </div>
            <div>
              <h2 className={resultClass.contactUsHeading}>Contact Us:</h2>
              <div className={resultClass.contactUsWrap}>
                <div>
                  <div style={subHeading}>{contactDetails.name}</div>
                  <div style={{ fontSize: isMobile ? 16 : 20 }}><span style={subHeading}>Email: </span>{contactDetails.email}</div>
                </div>
              </div>
            </div >
          </>
        )
      }
    </div >
  );
};

export default Results;
